<!--
 * @Author: zhaoliang
 * @Date: 2023-04-11 10:25:52
 * @LastEditTime: 2026-02-12 18:05:31
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/SignUpMFA/components/step1/index.vue
 *
-->
<template>
  <div>
    <div class="signup-box-title">
      <img src="~img/icon-lock-black.svg" alt="lock" />
      <span>{{ $i18n.t('signup-visa-card-details') }}</span>
    </div>
    <div class="signup-box-desc">
      <span>{{ $i18n.t('signup-desc') }}</span>
    </div>
    <div class="signup-box-form">
      <div class="signup-form">
        <!-- sign 姓名输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="visaCardName">{{ $i18n.t('visaCardName') }}*</label>
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{
                'signup-form-item': true,
                'input-border-err': nameInfoErr || cardInfoErr,
              }"
              :type="nameInputType"
              id="visaCardName"
              :placeholder="$i18n.t('visaCardName')"
              autocomplete="new-password"
              role="input name"
              v-model.trim="formData.visaCardName"
              maxlength="35"
              minlength="2"
              @input="
                e => {
                  handleValueChange(e, 'visaCardName');
                }
              "
            />
            <img
              v-show="showName"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeNameInputStatus('password')"
              alt="hide name"
            />
            <img
              v-show="!showName"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeNameInputStatus('text')"
              alt="show name"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="nameInfoErr" class="error-message">{{ nameErrMsg }}</p>
        </div>
        <!-- signup 卡号输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="visaCardNum">{{ $i18n.t('visaCardNum') }}*</label>
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{
                'signup-form-item': true,
                'input-border-err': cardNumInfoErr || cardInfoErr,
              }"
              :type="cardNumInputType"
              id="visaCardNum"
              :placeholder="$i18n.t('visaCardNum')"
              autocomplete="new-password"
              role="input card number"
              v-model.trim="formData.visaCardNum"
              maxlength="19"
              @input="
                e => {
                  handleValueChange(e, 'visaCardNum');
                }
              "
            />
            <img
              v-show="showCardNum"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeCardNumStatus('password')"
              alt="hide card number"
            />
            <img
              v-show="!showCardNum"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeCardNumStatus('text')"
              alt="show card number"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="cardNumInfoErr" class="error-message">{{ cardNumErrMsg }}</p>
        </div>
        <div class="form-layout-horizontal">
          <!-- signup 日期输入框 -->
          <div class="form-item-group">
            <div class="form-item-label">
              <label for="cardExpiryDate">{{ $i18n.t('cardExpiryDate') }}*</label>
            </div>
            <div class="form-item-component">
              <SafeInput
                :className="{
                  'signup-form-item': true,
                  'input-border-err': expiryDateInfoErr || cardInfoErr,
                }"
                :type="expiryDateInputType"
                id="cardExpiryDate"
                :placeholder="$i18n.t('cardExpiryDate')"
                autocomplete="new-password"
                role="input expiryDate"
                v-model.trim="formData.cardExpiryDate"
                maxlength="5"
                @input="
                  e => {
                    handleValueChange(e, 'cardExpiryDate');
                  }
                "
              />
              <img
                v-show="showExpDate"
                class="eye"
                src="~img/icon-feather-eye-on.svg"
                @click="changeExpiryDateStatus('password')"
                alt="hide expiryDate"
              />
              <img
                v-show="!showExpDate"
                class="eye"
                src="~img/icon-feather-eye-off.svg"
                @click="changeExpiryDateStatus('text')"
                alt="show expiryDate"
              />
            </div>
            <!-- check 错误提示 -->
            <p v-if="expiryDateInfoErr" class="error-message">{{ expiryDateErrMsg }}</p>
          </div>
          <!-- signup cvv输入框 -->
          <div class="form-item-group">
            <div class="form-item-label">
              <label for="cardNum">{{ $i18n.t('cardNum') }}*</label>
              <img src="~img/icon-cvv.svg" alt="cvv" class="img-cvv" />
            </div>
            <div class="form-item-component">
              <SafeInput
                :className="{
                  'signup-form-item': true,
                  'input-border-err': cvvInfoErr || cardInfoErr,
                }"
                :type="cvvInputType"
                id="cardNum"
                :placeholder="$i18n.t('cardNum')"
                autocomplete="new-password"
                role="input CVV"
                v-model.trim="formData.cardNum"
                maxlength="4"
                @input="
                  e => {
                    handleValueChange(e, 'cardNum');
                  }
                "
              />
              <img
                v-show="showCVV"
                class="eye"
                src="~img/icon-feather-eye-on.svg"
                @click="changeCvvStatus('password')"
                alt="hide CVV"
              />
              <img
                v-show="!showCVV"
                class="eye"
                src="~img/icon-feather-eye-off.svg"
                @click="changeCvvStatus('text')"
                alt="show CVV"
              />
            </div>
            <!-- check 错误提示 -->
            <p v-if="cvvInfoErr" class="error-message">{{ cvvErrMsg }}</p>
          </div>
        </div>
      </div>
      <p v-if="cardInfoErr" class="error-message">{{ cardErrMsg }}</p>
    </div>
    <div class="signup-terms-box">
      <ul>
        <li>{{ $t('signup-terms-desc-1') }}</li>
        <li>{{ $t('signup-terms-desc-2') }}</li>
        <li>
          <i18n-t keypath="signup-see-tnc" tag="p">
            <router-link to="/terms" target="_blank" class="tc-link">
              {{ $t('signup-tnc') }}
            </router-link>
          </i18n-t>
        </li>
      </ul>
      <div class="check-terms">
        <div class="check-box" @click="toggleCheck">
          <img v-show="checked" src="~img/icon-check.png" alt="checked icon" />
        </div>
        <span>{{ $i18n.t('signup-userdetails-agree') }}</span>
      </div>
    </div>
    <!-- check 错误提示 -->
    <p v-if="infoErr" class="error-message">{{ errorMsg }}</p>
    <div class="signup-box-button">
      <div class="signup-btn" :class="{ 'signup-btn-disable': buttonDisable }">
        <div v-if="!loading" @click="checkCard" role="button">
          <!-- <img src="~img/icon-lock.svg" alt="lock" /> -->
          <span>{{ $i18n.t('signup-userdetails-continue') }}</span>
        </div>
        <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
      </div>
    </div>
    <div class="signup-box-bottom">
      <span>{{ $i18n.t('signup-existing-user') }}</span>
      <span class="login-desc" @click="goToLogin">{{ $i18n.t('signup-userdetails-login') }}</span>
    </div>
  </div>
</template>
<script>
  import { getQueryString, getDeviceId } from '@/utils';
  import verify from '@/utils/verify';
  import { mapState } from 'vuex';
  import SafeInput from '@/components/SafeInput';
  import request from '@/utils/request';

  export default {
    name: 'SignUpMFAStep1',
    components: {
      SafeInput,
    },
    props: {},
    data() {
      return {
        // 姓名输入框
        nameInputType: 'password',
        nameInfoErr: false,
        nameErrMsg: '',
        // 卡号输入框
        cardNumInputType: 'password',
        cardNumInfoErr: false,
        cardNumErrMsg: '',
        // 过期时间输入框
        expiryDateInputType: 'password',
        expiryDateInfoErr: false,
        expiryDateErrMsg: '',
        // CVV输入框
        cvvInputType: 'password',
        cvvInfoErr: false,
        cvvErrMsg: '',
        // 验证卡的错误信息
        cardInfoErr: false,
        // cardErrMsg: this.$i18n.t('not-eligible'),
        // cardErrMsg: `${this.$i18n.t('invalid-entry')}.${this.$i18n.t('please-check-details')}`,
        cardErrMsg: '',
        // 勾选框
        checked: false,
        formData: {
          visaCardName: '',
          visaCardNum: '',
          cardExpiryDate: '',
          cardNum: '',
        },
        infoErr: false,
        errorMsg: '',
        loading: false,
        // 校验卡所需的参数
        projectId: '',
        visaToken: '',
        dpSessionId: '',
        encryptCustomerInput: '',
        // 注册时需要传回的参数
        cardInfoToken: '',
      };
    },
    computed: {
      showName() {
        return this.nameInputType === 'text';
      },
      showCardNum() {
        return this.cardNumInputType === 'text';
      },
      showExpDate() {
        return this.expiryDateInputType === 'text';
      },
      showCVV() {
        return this.cvvInputType === 'text';
      },
      buttonDisable() {
        const { visaCardName, visaCardNum, cardExpiryDate, cardNum } = this.formData;
        return !visaCardName || !visaCardNum || !cardExpiryDate || !cardNum || !this.checked;
      },
      ...mapState(['userInfo']),
    },
    mounted() {
      const payOrderNo = getQueryString('payOrderNo');
      const dpSessionId = localStorage.getItem('dpSessionId');
      if (payOrderNo) {
        this.$textLoading(true);
        this.ingenico3DSNotify(payOrderNo, dpSessionId);
      }
    },
    methods: {
      changeNameInputStatus(value) {
        this.nameInputType = value;
      },
      changeCardNumStatus(value) {
        this.cardNumInputType = value;
      },
      changeExpiryDateStatus(value) {
        this.expiryDateInputType = value;
      },
      changeCvvStatus(value) {
        this.cvvInputType = value;
      },
      toggleCheck() {
        this.checked = !this.checked;
      },
      checkCard() {
        console.log('check card');
        if (this.buttonDisable) return;
        verify({
          ...this.formData,
          visaCardNum: this.formData.visaCardNum.replace(/\s+/g, ''),
        }).then(async errMsg => {
          console.log(errMsg);
          if (errMsg.pass) {
            // 调用接口
            console.log('校验通过');
            // 获取projectid
            await this.getAvailable();
            // vces
            await this.vcesVerify();
          } else {
            errMsg.forEach(item => {
              switch (item.name) {
                case 'visaCardName':
                  this.nameInfoErr = true;
                  this.nameErrMsg = item.errMessage;
                  break;
                case 'visaCardNum':
                  this.cardNumInfoErr = true;
                  this.cardNumErrMsg = item.errMessage;
                  break;
                case 'cardExpiryDate':
                  this.expiryDateInfoErr = true;
                  this.expiryDateErrMsg = item.errMessage;
                  break;
                case 'cardNum':
                  this.cvvInfoErr = true;
                  this.cvvErrMsg = item.errMessage;
                  break;
                default:
                  break;
              }
            });
          }
        });
      },
      handleValueChange(e, key) {
        this.cardInfoErr = false;
        this.cardErrMsg = '';
        switch (key) {
          case 'visaCardName':
            this.nameInfoErr = false;
            this.nameErrMsg = '';
            break;
          case 'visaCardNum':
            this.cardNumInfoErr = false;
            this.cardNumErrMsg = '';
            break;
          case 'cardExpiryDate':
            this.expiryDateInfoErr = false;
            this.expiryDateErrMsg = '';
            break;
          case 'cardNum':
            this.cvvInfoErr = false;
            this.cvvErrMsg = '';
            break;
          default:
            break;
        }
        const { value } = e.target;
        if (key === 'visaCardNum') {
          const newValue = value
            .replace(/\s/g, '')
            .replace(/[^\d]/g, '')
            .replace(/(\d{4})(?=\d)/g, '$1 ');
          this.formData[key] = newValue;
        }
        if (key === 'cardNum') {
          // 判断cardNum当前的值是否为数字
          const newValue = value.replace(/\s/g, '').replace(/[^\d]/g, '');
          this.formData[key] = newValue;
        }
        if (key === 'cardExpiryDate') {
          // 判断cardExpiryDate当前的值是否为数字 + /
          const newValue = value
            .replace(/\s/g, '')
            .replace(/[^\d|/]/g, '')
            .replace(/(\d{2})(?=\d)/g, '$1/');
          this.formData[key] = newValue;
        }
      },
      goToLogin() {
        this.$router.push('/login');
      },
      // 获取可用区域
      getAvailable() {
        this.$textLoading(true);
        return this.$http.login
          .getAvailable({ lang: this.$i18n.locale })
          .then(res => {
            if (res.state === '11') {
              res.payload.forEach(item => {
                if (item.regionCode === 'canada') {
                  this.projectId = item.projectId;
                }
              });
            } else {
              console.error(res.note);
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
              this.$textLoading(false);
            }
          })
          .catch(err => {
            console.log(err, 'getAvailable');
            this.$textLoading(false);
          });
      },
      vcesVerify() {
        console.log('vcesVerify');
        this.$textLoading(true);
        const { visaCardNum, cardExpiryDate } = this.formData;
        const tokenCode = visaCardNum.replace(/\s+/g, '');
        const [expiryMonth, expiryYear] = cardExpiryDate.split('/');
        const params = {
          channel: this.projectId,
          tokenCode,
          expiryMonth,
          expiryYear,
          lang: localStorage.getItem('lang'),
        };
        return this.$http.login
          .vcesVerify(params)
          .then(res => {
            if (res.state === '1') {
              this.visaToken = res.result.id;
              // 获取支付渠道后判断走 checkout 或者 ingenico
              this.getPaymentChannel();
            } else {
              this.cardInfoErr = true;
              // 后端接口薛定谔的错误信息字段导致的兼容问题
              this.cardErrMsg = res.note || res.msg;
              this.$textLoading(false);
            }
          })
          .catch(err => {
            console.log(err, 'vcesVerify');
            this.$textLoading(false);
          });
      },
      // 获取支付渠道
      getPaymentChannel() {
        const params = {
          visaToken: this.visaToken,
          source: 1, // 注册
          lang: this.$i18n.locale,
          deviceId: getDeviceId(),
        };
        this.$http.login.getPaymentChannel(params).then(res => {
          if (res.state === '11') {
            console.log('payment channel', res.data);
            const { paymentChannel, pciCacheCardInfoUrl, caller, dpSessionId } = res.data;
            this.dpSessionId = dpSessionId;
            if (paymentChannel === 106) {
              // ingenico
              this.ingenicoVerify();
            } else if (paymentChannel === 167) {
              // checkout
              this.checkoutVerify(pciCacheCardInfoUrl, caller);
            }
          } else {
            console.error(res.note);
          }
        });
      },
      ingenicoVerify() {
        console.log('ingenicoVerify');
        this.$textLoading(true);
        // 创建session
        const { visaCardNum, visaCardName, cardNum, cardExpiryDate } = this.formData;
        const [expiryMonth, expiryYear] = cardExpiryDate.split('/');
        return this.$http.login
          .createSession()
          .then(res => {
            if (res.state === '11') {
              const sessionDetails = res.payload;
              const paymentDetails = {
                countryCode: 'US',
                currency: 'USD',
                isRecurring: false,
                locale: 'en_US',
                totalAmount: 0,
              };

              const cardNumber = visaCardNum.replace(/\s+/g, '');
              const cardholderName = visaCardName; // 不能是1位纯数字， 会提示length错误
              const cvv = cardNum;
              const date = expiryMonth + expiryYear;

              // this.startSession(cardNumber, paymentDetails, cvv, date, sessionDetails, name);

              const sliceCardNumber = cardNumber.slice(0, 6);
              const connect = require('connect-sdk-client-js/dist/connectsdk.noEncrypt');
              // eslint-disable-next-line new-cap
              const session = new connect(sessionDetails);

              session.getIinDetails(sliceCardNumber, paymentDetails).then(
                iinDetailsResponse => {
                  if (iinDetailsResponse.status !== 'SUPPORTED') {
                    this.$textLoading(false);
                    console.log(`Card check error: ${iinDetailsResponse.status}`);
                    const errorMsg = `Card check error: ${iinDetailsResponse.status}`;
                    this.cardInfoErr = true;
                    this.cardErrMsg = errorMsg;
                    /* this.$messageModal.show({
                    image: false,
                    desc: errorMsg,
                    i18nNeed: false,
                    closeIcon: true,
                    confirmBtn: 'ok',
                    justHide: true,
                  }); */
                    return;
                  }
                  session
                    .getPaymentProduct(iinDetailsResponse.paymentProductId, paymentDetails)
                    .then(
                      paymentProduct => {
                        const paymentRequest = session.getPaymentRequest();
                        paymentRequest.setPaymentProduct(paymentProduct);
                        paymentRequest.setValue('cardNumber', cardNumber);
                        paymentRequest.setValue('cvv', cvv);
                        paymentRequest.setValue('expiryDate', date);
                        paymentRequest.setValue('cardholderName', cardholderName);

                        if (!paymentRequest.isValid()) {
                          for (const error in paymentRequest.getErrorMessageIds()) {
                            console.error('error', error);
                          }
                        }

                        // 获取加密字符串
                        session
                          .getEncryptor()
                          .encrypt(paymentRequest)
                          .then(
                            paymentHash => {
                              this.encryptCustomerInput = paymentHash;
                              // mfa checkcard
                              this.checkCardInfo();
                            },
                            errors => {
                              console.log('errors1', errors);
                              this.$textLoading(false);
                              this.cardInfoErr = true;
                              this.cardErrMsg = `${this.$i18n.t('invalid-entry')}.${this.$i18n.t(
                                'please-check-details',
                              )}`;
                            },
                          );
                      },
                      errors => {
                        console.log('errors0', errors);
                        this.$textLoading(false);
                      },
                    );
                },
                errors => {
                  this.$textLoading(false);
                  console.log('errors2', errors);
                  const errorMsg = errors.json.errors[0].message;
                  console.log('errorMsg', errorMsg);

                  if (errorMsg === 'NO bin FOUND') {
                    this.cardInfoErr = true;
                    this.cardErrMsg = this.$i18n.t('not-eligible');
                    /* this.$messageModal.show({
                    image: false,
                    desc: 'not-eligible',
                    i18nNeed: true,
                    closeIcon: true,
                    confirmBtn: 'ok',
                    justHide: true,
                  }); */
                  } else {
                    this.cardInfoErr = true;
                    this.cardErrMsg = errorMsg;
                    /* this.$messageModal.show({
                    image: false,
                    desc: errorMsg,
                    i18nNeed: false,
                    closeIcon: true,
                    confirmBtn: 'ok',
                    justHide: true,
                  }); */
                  }
                },
              );
            } else {
              this.$textLoading(false);
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
            }
          })
          .catch(err => {
            console.log(err, 'createSession');
            this.$textLoading(false);
          });
      },
      checkoutVerify(pciCacheCardInfoUrl, caller) {
        this.$textLoading(true);
        console.log('checkoutVerify', pciCacheCardInfoUrl);
        // 调用 pciCacheCardInfoUrl, 获取 paymentToken
        request({
          url: pciCacheCardInfoUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            caller,
          },
          data: {
            cardNumber: this.formData.visaCardNum.replace(/\s+/g, ''),
            cardHolderName: this.formData.visaCardName,
            expireTime: this.formData.cardExpiryDate.replace('/', ''),
            cvv: this.formData.cardNum,
          },
        })
          .then(res => {
            if (res.state === '1') {
              const paymentToken = res.result?.token || '';
              this.checkCardInfo(paymentToken);
            } else {
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
              this.$textLoading(false);
            }
          })
          .catch(err => {
            console.log('checkout err', err);
            this.$textLoading(false);
          });
      },
      checkCardInfo(pciPaymentToken) {
        console.log('checkCardInfo');
        const params = {
          visaToken: this.visaToken,
          encryptCustomerInput: this.encryptCustomerInput,
          returnUrl: window.location.href,
          source: 1, // 注册
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId || null,
          pciPaymentToken,
          deviceUserAgent: navigator.userAgent,
          deviceLocale: this.$i18n.locale,
        };
        return this.$http.login
          .checkCardInfo(params)
          .then(res => {
            if (res.state === '11') {
              console.log('message', res.data);
              if (res.data.needThreeDS) {
                // 跳转链接,跳转之前保存表单数据,用于回填
                localStorage.setItem('visaToken', this.visaToken);
                localStorage.setItem('dpSessionId', this.dpSessionId);
                window.location.href = res.data.threeDSUrl;
              } else {
                this.cardInfoToken = res.data.cardInfoToken;
                // 信用卡是否被注册
                this.checkCardNoStatus();
              }
            } else {
              this.$textLoading(false);
              console.error(res.note);
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
            }
          })
          .catch(err => {
            this.$textLoading(false);
            console.log(err, 'checkCardInfo');
          });
      },
      ingenico3DSNotify(payOrderNo, dpSessionId) {
        const params = {
          payOrderNo,
          dpSessionId,
          deviceUserAgent: navigator.userAgent,
          deviceLocale: this.$i18n.locale,
          source: 1, // 注册
        };
        return this.$http.login
          .ingenico3DSNotify(params)
          .then(res => {
            if (res.state === '11') {
              this.cardInfoToken = res.data.cardInfoToken;
              this.checkCardNoStatus();
            } else {
              this.$textLoading(false);
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
            }
          })
          .catch(err => {
            this.$textLoading(false);
            console.log(err, 'ingenico3DSNotify');
          });
      },
      checkCardNoStatus() {
        const params = {
          token: this.visaToken || localStorage.getItem('visaToken'),
          lang: localStorage.getItem('lang'),
        };
        return this.$http.login
          .checkCardNoStatus(params)
          .then(res => {
            if (res.state === '11') {
              this.$textLoading(false);
              this.nextStep();
            } else {
              this.$textLoading(false);
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
            }
          })
          .catch(err => {
            this.$textLoading(false);
            console.log(err, 'checkCardNoStatus');
          });
      },
      nextStep() {
        console.log('下一步');
        this.$emit('nextStep', {
          cardInfoToken: this.cardInfoToken,
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile.scss';
</style>
